import React, { useState, useEffect, useRef, Fragment, useMemo, act, useCallback } from "react";
import LayoutHOC from "../LayoutHOC";
import taskPodHead from "../customer/TaskPodHead";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { ReactComponent as NoALL } from "../../assets/images/icons/NoAll.svg";
import useRequireAuth from "../../utils/useRequireAuth";
import { useParams } from "react-router-dom";
import { ReactComponent as TaskIcon } from "../../assets/images/icons/TaskIcon.svg";
import { ReactComponent as NotStartedIcon } from "../../assets/images/icons/NotStartedIcon.svg";
import { ReactComponent as WorkInProgressIcon } from "../../assets/images/icons/WorkInProgressIcon.svg";
import { ReactComponent as CompletedIcon } from "../../assets/images/icons/CompletedIcon.svg";
import { ReactComponent as CancelledIcon } from "../../assets/images/icons/CancelledIcon.svg";
import { ReactComponent as DropIcon } from "../../assets/images/icons/DropIcondash.svg";
import { ReactComponent as HoldIcon } from "../../assets/images/icons/HoldIcon.svg";
import { ReactComponent as DefaultIcon } from "../../assets/images/icons/DefaultIcon2.svg";
import { ReactComponent as SubTaskIconClosed } from "../../assets/images/subtaskClosedIcon.svg";
import { ReactComponent as SubTaskIconOpen } from "../../assets/images/subTaskOpenIcon.svg";
import {
  useDeleteProjectMutation,
  useDeleteTaskMutation,
  useFetchCustomerTaskPodAllCustomerDataQuery,
  useFetchCustomerTaskPodTableDataQuery,
  useFetchTaskHeaderConfigurationQuery,
  useLazyGetProjectTaskEnumQuery,
  usePostApiMutation,
  useUpdateCustomerTaskPodTableDataMutation,
  useUpdateTaskCompletionMutation,
} from "../../utils/customer/customerTaskTable";
import { customFilterFn } from "../../utils/utilityFunctions/customFilterFn";
import { useLazyFetchPersonInTableQuery } from "../../utils/customer/customerTable";
import QuickFilter from "../GlobalFeature/Table/HeadTop/QuickFilter";
import { getUserTokeData } from "../../utils/userSlice";
import { useLocation } from "react-router-dom";
import useFormatDate from "../../hooks/DateFormatter/useFormatDate";
import styled from "@emotion/styled";
import EditOptionsModal from "./TaskRecurrence/EditOptionsModal";
import { ReactComponent as KanBanBoardSvg } from "../../assets/images/icons/KanBanBoardSvg.svg";
import { safeJsonParse } from "../../utils/utilityFunctions/stringUtility";
import CustomerEditTaskActivity from "../customer/CustomerEditTaskActivity";
import { ReactComponent as ActivityIcon } from "../../assets/images/ActivityIcon.svg";
import { ReactComponent as ProjectIcon } from "../../assets/images/icons/ProjectIcon.svg";
import { ReactComponent as ViewNotes } from "../../assets/images/ViewNotes.svg";
import { ReactComponent as NoProject } from "../../assets/images/icons/NoProjectImg.svg";
import { ReactComponent as NoJobs } from "../../assets/images/icons/NoJobs.svg";
import Loader from "../UniversalComponents/Loader";
import { pushAlert } from "../../utils/alertSlice";
import { useSidebar } from "../SidebarContext";
import ConfirmationDialog from "../UniversalComponents/ConfirmationDialogMulti";
import ToDoActiveButton from "../TaskPod/ToDoActiveButton";
import AvatarName from "../UniversalComponents/AvatarName";
import { ReactComponent as GridIcon } from "../../assets/images/icons/GridIcon.svg";
import { ReactComponent as ListIcon } from "../../assets/images/icons/ListIcon.svg";
import TaskRadioButton from "../Task/TaskCompletionBox";
import AddViewProjectDrawer from "../TaskPod/AddViewProjectDrawer";
import CustomerReactTable from "../UniversalComponents/CustomerReactTable";
import { ReactComponent as EmailIcon } from "../../assets/images/emailCustomerCard.svg";
import { ReactComponent as PhoneIcon } from "../../assets/images/PhoneIconCustomerCard.svg";
import { ReactComponent as NullTag } from "../../assets/images/icons/NullTag.svg";
import { ReactComponent as Tagslength } from "../../assets/images/icons/Tagslength.svg";
import { ReactComponent as NullPriority } from "../../assets/images/icons/NullPriority.svg";
import { ReactComponent as HighPriority } from "../../assets/images/icons/HighPriority.svg";
import { ReactComponent as MediumPriority } from "../../assets/images/icons/MediumPriority.svg";
import { ReactComponent as LowPriority } from "../../assets/images/icons/LowPriority.svg";
import { ReactComponent as UrgentPriority } from "../../assets/images/icons/UrgentPriority.svg";
import { ReactComponent as AtachmentTaskTable } from "../../assets/images/icons/attachmentTaskTable.svg";
import { ReactComponent as SearchItemNotFound } from "../../assets/images/searchItemNotFound.svg";
import { ReactComponent as AddSubTask } from "../../assets/images/icons/AddSubTask.svg";
import { ReactComponent as DuplicateTask } from "../../assets/images/icons/DuplicateTask.svg";
import { ReactComponent as CopyToTask } from "../../assets/images/icons/CopyToTask.svg";
import { ReactComponent as ReccurenceTaskIcons } from "../../assets/images/icons/ReccurenceTaskIcon.svg";
import { ReactComponent as LinkTask } from "../../assets/images/icons/LinkTask.svg";
import ToolTipComponent from "../UniversalComponents/ToolTipComponent";
import CopyIconComponent from "../UniversalComponents/CopyIconComponent";
import HighlightedParagraph from "../UniversalComponents/HighlightedParagraph";
import { formatToDDMMMYYYY } from "../../utils/utilityFunctions/dateUtility";
import { transformListObject } from "../../utils/utilityFunctions/listObject";
import KanBanBoard from "./Kanban/KanBanBoard";
import ToggleMultiSwitch from "../UniversalComponents/ToggleMultiSwitch";
import { ReactComponent as NoTask } from "../../assets/images/NotaskData.svg";
import { NODE_URL } from "../../utils/constants";
import RevampedTaskCalendar from "./TaskRecurrence/RevampedTaskCalendar";
import { usePollingWithReset } from "../UniversalComponents/usePollingWithReset";
import {
  useFetchAllTemplateQuery,
  useLazyFetchAllTasksQuery,
  useLazyFetchLinkedSectionsFieldsQuery,
} from "../../utils/customer/customerSelect";
import { hideLoader, showLoader } from "../../utils/loaderSlice";
import DynamicAddTaskPodModal from "./DynamicAddTaskPodModal";
import InternalNavigation from "../UniversalComponents/InternalNavigation";
import ManageFieldDrawer from "../customer/CustomModule/ManageFieldDrawer";
import ManageIcon from "../../assets/images/icons/ManageIcon";
import TableDashboard from "../UniversalComponents/TableDashboard";
import { getUserDateTime } from "../../utils/utilityFunctions/UTCFormat";
import StatusDashboard from "../UniversalComponents/StatusDashboard";
import AddItemPlus from "../UniversalComponents/AddItemPlus";
import Button from "../UniversalComponents/DefaultButton";
import DeleteConfirmModal from "./DeleteConfirmationModal";
import { getTitleCase } from "./../../utils/utilityFunctions/stringUtility";
import { getUserId } from "../../utils/utilityFunctions/localServices";

const getTextAlignment = (type) => {
  switch (type) {
    case "text":
      return "left";
    case "number":
      return "right";
    case "date":
      return "center";
    case "time":
      return "center";
    default:
      return "left";
  }
};

const assignmentList = safeJsonParse(localStorage.getItem("assignmentList"));
const toggleStatus = (value) => {
  if (value === "Completed") return "Not Started";
  return "Completed";
};

function toggleVisibility(obj, key) {
  if (!(key in obj)) return obj; // no change if key missing

  // Toggle the value
  const updated = { ...obj, [key]: !obj[key] };

  // Sort keys so true values come first
  const sortedEntries = Object.entries(updated).sort(([, aVal], [, bVal]) => {
    return (bVal === true) - (aVal === true); // true before false
  });

  // Rebuild object in sorted order
  return Object.fromEntries(sortedEntries);
}

const TaskCompletionCheckbox = ({ id, isChecked, task_status_id, taskData, handleClickCompleted }) => {
  return (
    <div
      className={`flex items-center text-black ${isChecked ? "" : ""}`}
      onClick={(e) => handleClickCompleted(e, id, task_status_id, taskData)}
    >
      <TaskRadioButton isChecked={isChecked} />
    </div>
  );
};

const AllTasks = ({
  customerTask,
  // leadType,
  subNavitems,
  disableLeadTypeChange,
  customerData,
  propTemplateId,
  moduleTaskId = null,
  fullScreen = false,
}) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const location = useLocation();
  const hasMyActivities = location.pathname.includes("my-activities")
    ? 1
    : location.pathname.includes("my-assignment")
      ? 0
      : null;

  const { tab: tabValue, leadTypePath } = useParams();
  const [searchParams, setSearchParams] = useSearchParams();
  const [isManageFieldOpen, setIsManageFieldOpen] = useState(false);

  const listView = searchParams.get("listView") || "list";
  const dayView = searchParams.get("view");

  const [resetPageIndex, setResetPageIndex] = useState(true);
  const [formateColumn, setFormateColumn] = useState([]);
  const [dashBoardFilterValue, setDashBoardFilterValue] = useState(null);
  const hashValue = location.hash;

  const [quiFilter, setQuiFilter] = useState();
  const [initialFilter, setInitialFilter] = useState([]);
  const [taskIDList, setTaskIDList] = useState([]);
  const [customer, setCustomer] = useState([]);
  const [customerMainData, setCustomerMainData] = useState([]);
  const [subRoutingData, setSubRoutingData] = useState(null);
  const [activeTab, setActiveTab] = useState(searchParams.get("activeTab") || "all");
  const [allSubTaskOpen, setAllSubTaskOpen] = useState(false);
  const token = useRequireAuth();

  const storedData = localStorage.getItem("company_data");

  const companyId = storedData ? JSON.parse(storedData) : null;
  const [parentTaskData, setParentTaskData] = useState(null);
  const [customerTablePagination, setCustomerTablePagination] = useState("");
  const { name: taskPod, id: customerId } = useParams();
  const [refreshKey, setRefreshKey] = useState(0);
  const showMessage = useSelector((state) => state.tasks.showMessage);
  const [alert, setAlert] = useState({ visible: false, message: "", type: "" });
  const [editData, setEditData] = useState();
  const [subTaskData, setSubTaskData] = useState(null);
  const [dashBoardCountList, setDashBoardCountList] = useState([]);
  const [isEditPopupOpen, setIsEditPopupOpen] = useState(null);
  const [loading, setLoading] = useState(false);
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [view, setView] = useState(dayView === "Day");

  const [newPayload, setNewPayload] = useState([]);
  const [isFilterActive, setIsFilterActive] = useState(false);
  const [globalFilter, setGlobalFilter] = useState(null);
  const [isSearchActive, setIsSearchActive] = useState(null);

  const [openSubTaskDrawer, setOpenSubTaskDrawer] = useState(false);
  const [userDataId, setUserDataId] = useState([]);
  const [totalData, setTotalData] = useState(null);
  const [showLeftArrow, setShowLeftArrow] = useState(false);
  const [showRightArrow, setShowRightArrow] = useState(false);
  const [storedThead, setStoredThead] = useState(taskPodHead || []);
  const [isHovered, setIsHovered] = useState(false);
  const [isFilterHovered, setIsFilterHovered] = useState(false);
  const taskFormSubmit = useSelector((state) => state.tasks);
  const [completedTasks, setCompletedTasks] = useState([]);
  const [templateId, setTemplateId] = useState(null);
  const [dynamicHeaders, setDynamicHeaders] = useState(null);

  const [openAddProject, setOpenAddProject] = useState(false);
  const [projectFormData, setProjectFormData] = useState(null);
  const [CustomerEditId, setCustomerEditId] = useState();
  const [isCustomerDrawer, setIsCustomerDrawer] = useState(false);
  const [isEditMode, setIsEditMode] = useState(true);
  const [addCustomerId, setAddCustomerId] = useState("");
  const [multiData, setMultiData] = useState({});
  const [seriesRecurModel, setSeriesRecurModel] = useState(false);
  //state for view switch between compact and detailed view
  const [viewMode, setViewMode] = useState("detailed");
  const scrollDiv = useRef();
  const moreTabRef = useRef();
  const tabListRef = useRef();
  // const [kanban, setKanBan] = useState(listView === "kanban")

  const kanban = listView === "kanban";
  const addQueryParam = (key, value) => {
    const searchParams = new URLSearchParams(location.search);

    searchParams.set(key, value); // adds or replaces param

    navigate({
      pathname: location.pathname,
      search: searchParams.toString(),
    });
  };

  //static data headers
  const {
    data: taskHeaderCongiguration,
    isFetching: isTaskHeaderConfigurationLoading,
    isLoading: headerLoading,
    isError: headerError,
    refetch: refetchTaskHeader,
  } = useFetchTaskHeaderConfigurationQuery(
    {
      entity: templateId === "projects" ? "all_project" : templateId,
      customer_id: customerId,
    },
    {
      skip: templateId !== "projects",
    }
  );

  //dynamic templete header
  const [
    GetLinkedSectionFields,
    {
      data: dynamicHeaderValues,
      isLoading: isDyanmicHeaderLoading,
      isError: isDyanmicHeaderError,
      isSuccess: isDyanmicHeaderSuccess,
      error: DyanmicHeaderError,
    },
  ] = useLazyFetchLinkedSectionsFieldsQuery({ TemplateId: templateId, template_id: propTemplateId });

  const [
    GetAllTasks,
    {
      data: fetchGetAllTasks,
      isLoading: isfetchGetAllTasksLoading,
      isError: isfetchGetAllTasksError,
      isSuccess: isfetchGetAllTasksSuccess,
      error: fetchGetAllTasksError,
    },
  ] = useLazyFetchAllTasksQuery();

  const handleRefetchGetAllTasks = () => {
    GetAllTasks({
      taskTemplateId: templateId,
      template_id: propTemplateId,
      visibility_status: activeTab,
      quiFilter: quiFilter ? quiFilter?.value : null,
      customer_id: customerTask ? customerId : null,
      filter_status: dashBoardFilterValue ? dashBoardFilterValue : null,
    });
  };
  const fetchKanbanData = async () => {
    const response = await GetAllTasks({
      taskTemplateId: templateId,
      is_kanban: true,
      customer_id: customerTask ? customerId : null,
      Filter: quiFilter ? quiFilter?.value : null,
    });
  };

  useEffect(() => {
    //to stop new apis from being called when templateId is projets or null\
    if (!templateId || templateId === "projects") return;

    GetLinkedSectionFields({
      TemplateId: templateId,
      IsForm: false,
      template_id: propTemplateId,
      is_company_level: !customerTask ? true : false,
      is_compact_view: viewMode === "compact",
    });
    if (listView === "kanban") {
      fetchKanbanData();
    } else {
      handleRefetchGetAllTasks();
    }
  }, [templateId, listView, activeTab, quiFilter?.value, dashBoardFilterValue, viewMode]);

  const { data: customerTaskPodAllCustomer } = useFetchCustomerTaskPodAllCustomerDataQuery({
    token,
    companyId,
    // search: customerSearch,
  });

  const [fetchFieldValues, { data: projectFieldList, isFetching: projectFieldListLoading }] =
    useLazyGetProjectTaskEnumQuery();
  let scrollInterval;
  // = useRef();
  const sidebarContext = useSidebar();
  const setheaderProps = sidebarContext?.setheaderProps;
  const headerProps = sidebarContext?.headerProps;

  useEffect(() => {
    if (!customerTask) {
      if (location.pathname.includes("/my-activities/")) setheaderProps({ name: "My Activities", ActionTab: ViewData });
      if (location.pathname.includes("/my-assignment/"))
        setheaderProps({ name: "My Assignment", ActionTab: templateId === "projects" ? () => {} : ViewData });
    } else {
      setheaderProps({ ...headerProps, ActionTab: templateId === "projects" ? () => {} : ViewData });
    }

    return () => {
      if (
        (location.pathname.includes("/my-activities/") || location.pathname.includes("/my-assignment/")) &&
        !customerTask
      ) {
        setheaderProps(null);
      } else {
        setheaderProps({ ...headerProps, ActionTab: null });
      }
    };
  }, [setheaderProps, listView, templateId]);

  useEffect(() => {
    setView(dayView);
  }, [dayView]);

  useEffect(() => {
    if (moduleTaskId) {
      setTemplateId(moduleTaskId);
    } else if (leadTypePath) {
      setTemplateId(leadTypePath);
    } else {
    }
  }, [leadTypePath, moduleTaskId]);

  useEffect(() => {
    const transformedData = transformListObject(taskHeaderCongiguration?.data);
    setStoredThead(transformedData);
  }, [taskHeaderCongiguration?.data, headerLoading]);

  const getMoreTabStatus = (ele) => {
    if (ele && ele.current) {
      const rec = ele.current.getBoundingClientRect();

      if (rec.width > 850) {
        setShowLeftArrow(true);
        setShowRightArrow(true);
        // return true
      }
    }

    return false;
  };

  useEffect(() => {
    if (!isFilterActive) {
      setIsFilterHovered(false);
    }
  }, [isFilterActive]);

  const FilterTaskId = () => {
    setAllSubTaskOpen((prev) => {
      if (!prev) {
        taskIDList?.forEach((item, id) => {
          setSubtaskExpanded((prev) => ({
            ...prev,
            [id]: !prev[id],
          }));
        });
      } else {
        setSubtaskExpanded({});
      }
      return !prev;
    });
  };

  useEffect(() => {
    if (!isSearchActive) {
      setIsHovered(false);
    }
  }, [isSearchActive]);

  const [open, setOpen] = useState(false);
  const [dropUp, setDropUp] = useState(false);

  const pageSizes = [25, 50, 100];

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    if (open && dropdownRef.current) {
      const rect = dropdownRef.current.getBoundingClientRect();
      const windowHeight = window.innerHeight;

      if (rect.bottom + 100 > windowHeight) {
        setDropUp(true);
      } else {
        setDropUp(false);
      }
    }
  }, [open]);

  const child1Ref = useRef(null);
  const scrollbarWrapperRef = useRef(null);

  //for setting column Order
  useEffect(() => {
    const order = storedThead?.map((item) => Object.keys(item)[0]);
    setColumnOrder(order);
  }, [storedThead]);

  useEffect(() => {
    const child1 = child1Ref.current;
    const scrollbarWrapper = scrollbarWrapperRef.current;
    if (child1 && scrollbarWrapper) {
      const handleScroll = () => {
        if (child1.scrollLeft !== scrollbarWrapper.scrollLeft) {
          child1.scrollLeft = scrollbarWrapper.scrollLeft;
        }
      };

      const handleChild1Scroll = () => {
        if (scrollbarWrapper.scrollLeft !== child1.scrollLeft) {
          scrollbarWrapper.scrollLeft = child1.scrollLeft;
        }
      };

      scrollbarWrapper.addEventListener("scroll", handleScroll);
      child1.addEventListener("scroll", handleChild1Scroll);
    }
  }, []);

  const renderTabs = () => (
    <>
      {customerTableALL?.task_count &&
        Object.entries(customerTableALL.task_count).map(([key, count], i) => (
          <>
            <li key={key} id={`tab-${key}`}>
              <a
                href={`#${key}`}
                onClick={() => handleTabClick(`#${key}`)}
                className={`flex min-w-[69px] justify-center items-center py-1 px-2.5 focus:block whitespace-nowrap 
                leading-normal font-normal text-sm capitalize rounded-[50px] bg-white border 
                ${activeTab === `#${key}` ? "border-2C495D text-1D4469" : "border-D2DAE1 text-848687"}  
                ${key.toLowerCase() === "overdue" && "text-FF3612"} `}
              >
                {key}
              </a>
            </li>
          </>
        ))}
    </>
  );

  useEffect(() => {
    getMoreTabStatus(tabListRef);
  }, [renderTabs]);

  const [grouping, setGrouping] = useState([]);
  const [columnOrder, setColumnOrder] = useState([]);
  const [expanded, setExpanded] = useState({});
  const [openDropdownId, setOpenDropdownId] = useState(null);
  const [isPopupOpenActivity, setIsPopupOpenActivity] = useState(false);
  const [popupItemId, setPopupItemId] = useState(null);
  const [taskpodPayload, setTaskpodPayload] = useState(null);
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [deleteData, setDeleteData] = useState(false);
  const [updateCounter, setUpdateCounter] = useState(0);
  const [isDetailsVisible, setDetailsVisible] = useState(false);
  const [clickeditem, setClickedItem] = useState({});
  const [viewNotesData, setViewNotesData] = useState(null);
  const [isAdvancedFilterOpen, setIsAdvancedFilterOpen] = useState(false);

  const freshPollingCounter = useRef(0);
  // const [isListView, setIsListView] = useState(true);

  const [columnSearchTerms, setColumnSearchTerms] = useState(null);
  const dropdownRef = useRef(null);
  const [subtaskExpanded, setSubtaskExpanded] = useState({});

  const toggleSubtaskExpanded = (event, rowId) => {
    event.stopPropagation();
    setSubtaskExpanded((prev) => ({
      ...prev,
      [rowId]: !prev[rowId],
    }));
  };

  useEffect(() => {
    function handleOutsideClick(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setOpenDropdownId(null); // Close the dropdown
      }
    }

    document.addEventListener("mousedown", handleOutsideClick);

    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, [setOpenDropdownId]);

  //test for duplicate column in grouping column

  const defaultOrder = [];

  React.useEffect(() => {
    if (grouping.length > 0) {
      setColumnOrder((prevOrder) => {
        // Get remaining columns in their original order
        const remainingColumns = defaultOrder.filter((col) => !grouping.includes(col) && col !== "groupedColumn");

        return ["groupedColumn", ...remainingColumns];
      });
    } else {
      setColumnOrder((prevOrder) => defaultOrder.filter((col) => col !== "groupedColumn"));
    }
    const newVisibility = {};
    grouping?.forEach((group) => {
      newVisibility[group] = false;
    });
    setColumnVisibility({ ...columnVisibility, ...newVisibility, groupedColumn: grouping.length > 0 });
  }, [grouping]);

  const toggleRowExpansion = (rowId) => {
    setExpanded((prevExpanded) => {
      const newExpanded = { ...prevExpanded };
      if (newExpanded[rowId]) {
        delete newExpanded[rowId]; // Collapse the row if already expanded
      } else {
        newExpanded[rowId] = true; // Expand the row if collapsed
      }
      return newExpanded;
    });
  };
  const handleCustomerNameClick = (e, id) => {
    e.stopPropagation();
    window.open(`/customer/${id}`, "_blank");
  };
  const handleMouseEnterDebounced = (e, item) => {
    // e.stopPropagation()
    setPopupItemId(item?.id);
    setIsPopupOpenActivity(true);
  };

  const handleClosed = () => {
    setPopupItemId(null);
    setIsPopupOpen(false);
    // activityClosed();
  };

  const handleProjectIconClick = (e, data) => {
    e.stopPropagation();
    setEditData(data);
  };

  const handleClickCompleted = (e, id, task_status_id, taskData) => {
    e.stopPropagation();
    setUpdateCounter((prevCounter) => prevCounter + 1);
    setCompletedTasks((prevTasks) => ({
      ...prevTasks,
      [id]: {
        task_status_id: !prevTasks[id] ? task_status_id : null,
        status: toggleStatus(!prevTasks[id] ? taskData?.status : prevTasks[id]?.status),
      },
    }));

    const updatedTasks = {
      ...completedTasks,
      [id]: {
        task_status_id: !completedTasks[id] ? task_status_id : null,
        status: toggleStatus(!completedTasks[id] ? taskData?.status : completedTasks[id]?.status),
      },
    };

    const CompleteData = {
      task_id: Object.keys(updatedTasks).filter((key) => updatedTasks[key]?.status === "Completed"),
      task_status_id: Object.keys(updatedTasks)
        .filter((key) => updatedTasks[key]?.status === "Completed")
        .map((key) => updatedTasks[key]?.task_status_id),
      updates: {
        status: "Completed",
      },
    };

    const NotStartedData = {
      task_id: Object.keys(updatedTasks).filter((key) => updatedTasks[key]?.status === "Not Started"),
      task_status_id: Object.keys(updatedTasks)
        .filter((key) => updatedTasks[key]?.status === "Not Started")
        .map((key) => updatedTasks[key]?.task_status_id),
      updates: {
        status: "Not Started",
      },
    };

    const completedPayload = {
      data: CompleteData,
    };

    const NotStartedPayload = {
      data: NotStartedData,
    };

    const revertCompletionChanges = () => {
      setCompletedTasks({});
    };

    const updateApi = async () => {
      const apiResponseCompleted =
        Object.keys(completedPayload?.data?.task_id)?.length && (await updateTaskCompletion(completedPayload).unwrap());
      const apiResponseNS =
        Object.keys(NotStartedPayload?.data?.task_id?.filter((key) => key))?.length &&
        (await updateTaskCompletion(NotStartedPayload).unwrap());

      if (apiResponseCompleted?.success || apiResponseNS?.success) {
        dispatch(pushAlert({ type: "success", message: "Task updated successfully", visible: true }));

        handleRefetchGetAllTasks();
      } else {
        dispatch(pushAlert({ type: "danger", message: "Task Not updated", visible: true }));
        revertCompletionChanges();
      }
    };

    dispatch(
      pushAlert({
        type: "revert",
        message: "",
        visible: true,
        counter: updateCounter,
        onConfirm: updateApi,
        onRevert: revertCompletionChanges,
      })
    );
  };

  // edit the SubTask card Data
  const handleSubTaskCardClick = (data) => {
    setEditData(data);
    setIsPopupOpen(true);
  };
  const isMyTaskCompleted = (status, id) => {
    if (completedTasks[id] ? completedTasks[id]?.status === "Completed" : status === "Completed") {
      return true;
    }
    return false;
  };

  const getFieldValue = async (enumValues, entity = "project") => {
    const payload = {
      entity: entity,
      field: enumValues,
    };
    const response = await fetchFieldValues({ payload }).unwrap();
    if (response?.success) {
      dispatch(pushAlert({ message: response?.message, type: "success", visible: true }));
    } else {
      dispatch(pushAlert({ message: response?.message, type: "danger", visible: true }));
    }
  };

  const POPUserDrawer = (item) => {
    setCustomerEditId(item.id);
    setIsCustomerDrawer(true);
    setIsEditMode(false);
    setAddCustomerId(item?.id);
  };
  const CustomerTableCard = (data) => {
    return (
      <div className=" mb-2">
        <div className="flex items-center gap-3 mt-2 border-b-2 pb-1">
          <div className="flex  justify-center items-center gap-[22.957px] shrink-0">
            <AvatarName
              name={
                data?.customer_display_name
                  ? data.customer_display_name
                      .split(" ")
                      .splice(0, 2)
                      .map((name) => name[0]?.toUpperCase())
                      .join("")
                  : "N/A"
              }
              size="small"
              bgColor={"#E8ECF299"}
              textColor={"#7C7C83"}
              borderColor={"#ABABAC"}
            />
          </div>
          <div className="text-[#1D4469] font-poppins text-sm font-medium leading-normal capitalize truncate max-w-[150px]">
            {data?.customer_display_name}
          </div>
        </div>
        <div className="flex flex-col gap-2 border-b-2 pb-1 ">
          <div className="mt-3 flex items-center justify-between gap-4">
            <div className="flex items-center gap-2">
              <div className="">
                <EmailIcon />
              </div>
              <div className="text-[#E95F56] font-poppins text-xs font-normal lowercase max-w-[9rem] truncate">
                {data?.email}
              </div>
            </div>
            <div>
              <CopyIconComponent copyValue={data?.email} />
            </div>
          </div>
          <div
            className="flex items-center justify-between"
            // onClick={() => {
            //   handleCopy(data?.phone);
            // }}
          >
            <div className="flex items-center gap-2">
              <div className="">
                <PhoneIcon />
              </div>
              <div
                className="text-[#2999BC] font-poppins text-xs font-normal lowercase max-w-[9rem] truncate
    "
              >
                {data?.phone}
              </div>
            </div>
            <CopyIconComponent copyValue={data?.phone} />
          </div>
        </div>
        <div className="flex justify-end mt-2 mb-1 text-[#1D4469] font-poppins text-xs font-normal capitalize underline decoration-solid">
          <button className="text-blue-500 inline-block" onClick={() => POPUserDrawer(data)}>
            Show More
          </button>
        </div>
      </div>
    );
  };
  const handleViewNotesClick = (rowData) => {
    setViewNotesData(rowData);
  };
  function getInitials(name) {
    if (!name) return "";

    // split by dot OR space (regex handles both)
    const parts = name?.trim().split(/[.\s]+/);

    const first = parts[0]?.charAt(0) || "";
    const second = parts[1]?.charAt(0) || "";

    return (first + second).toLowerCase();
  }

  const handleSubTaskOpen = (data, subTask) => {
    setSubTaskData({ ...data, subTask });
    setIsPopupOpen(true);
  };
  const taskPageFilterFn = (row, columnId, filterValue) => {
    // ✅ Show all rows when no filter applied
    if (!filterValue || filterValue.length === 0) return true;

    const cellValue = row.getValue(columnId);
    if (!cellValue) return false;

    const normalize = (v) =>
      String(v || "")
        .trim()
        .toLowerCase();

    // 🟢 Case 1: cell value is an array (e.g., assigned_to)
    if (Array.isArray(cellValue)) {
      return filterValue.some((filterItem) => {
        const filterEmail = typeof filterItem === "string" ? normalize(filterItem) : normalize(filterItem.email);

        // match if any assigned person's email includes selected filter
        return cellValue.some((person) => normalize(person.email).includes(filterEmail));
      });
    }

    // 🟢 Case 2: cell value is string or number
    const normalizedCell = normalize(cellValue);
    return filterValue.some((filterItem) => {
      const filterText = typeof filterItem === "string" ? normalize(filterItem) : normalize(filterItem.email);
      return normalizedCell.includes(filterText);
    });
  };

  const colorObject = {
    Low: "#AEAEAE", // green
    Medium: "#003DC8", // amber
    High: "#EAAC00", // red
  };

  const columns = useMemo(() => {
    const staticColumn = [
      ...(grouping.length === 0 && templateId !== "projects"
        ? [
            {
              id: "completionAction",
              header: "",
              cell: (info) => {
                // const { project_name } = info.row.original;
                const getTaskKey = (task) => {
                  // return task.is_recurrence ? `recurrence-${task.task_status_id}` : `task-${task.id}`;
                  return task?.id;
                };

                const taskKey = getTaskKey(info.row.original);

                return (
                  <div className="flex items-center justify-end gap-3 w-full">
                    <TaskCompletionCheckbox
                      key={taskKey}
                      id={taskKey}
                      task_status_id={info.row.original.task_status_id}
                      taskData={info.row.original}
                      isChecked={
                        completedTasks[taskKey]
                          ? completedTasks[taskKey].status === "Completed"
                          : info.row.original.status === "Completed"
                      }
                      handleClickCompleted={handleClickCompleted}
                    />
                    <div
                      style={{ backgroundColor: colorObject[info.row.original.priority] }}
                      className="w-[3px] min-h-7"
                    ></div>
                  </div>
                );
              },
            },
          ]
        : []),
    ];
    if (grouping?.length) {
      staticColumn.push({
        id: "groupedColumn",
        header: ({ table }) =>
          grouping.length > 1
            ? "Group"
            : table
                .getAllColumns()
                .filter((col) => col.columnDef.accessorKey === grouping[0])
                .map((col) => col.columnDef.header)[0] || grouping[0],
        cell: () => null,
      });
    }
    const groupByLabel = (value) => {
      if (Array.isArray(value)) {
        return value
          .map((v) => v?.label || v?.name)
          .sort()
          .join(", ");
      }
      if (value && typeof value === "object") {
        return value.label ?? "";
      }
      return value ?? "";
    };

    const formatUTCToCompact = (utcString) => {
      return utcString?.slice(0, 10)?.replaceAll("-", "");
    };

    const dynamicColumns =
      dynamicHeaders
        ?.filter((header) => header?.is_visible === 1)
        ?.map((header) => ({
          // only that header field be visible
          accessorKey: header?.value,
          accessorFn: (row) => groupByLabel(row[header?.value]), // Use value key for accessorKey
          header: header.label, // Use label key for header
          meta: { position: "left", filterVariant: "select", type: header?.type }, // Add meta with default position
          // enableFiltering: false,
          // filterVariant: "select",
          // ...(header.value=="notes" && {enableColumnFilter: false}),

          ...(isAdvancedFilterOpen ? { filterFn: customFilterFn } : { filterFn: taskPageFilterFn }),
          ...([].includes(header?.value) && { enableColumnFilter: false }),

          sortUndefined: "1", // Disable filtering by default
          cell: (info) => {
            const value = info.getValue();

            //extra logic for viewmodeswitch

            if (viewMode === "compact") {
              if (header?.value === "customer_display_name") {
                return (
                  <div className="flex flex-col gap-y-[2px]">
                    <span className="text-[#131313CC] font-inter text-[12px] font-medium leading-normal">
                      {info.row.original.customer_display_name}
                    </span>
                    <span className="text-[#13131399] font-[Inter] text-[11px] font-normal leading-normal">
                      {info.row.original.customer_name}
                    </span>
                  </div>
                );
              }
            }

            if (header.value === "customer_name") {
              return (
                <div className="flex justify-between overflow-hidden text-ellipsis">
                  <div className="overflow-hidden text-ellipsis cursor-pointer">
                    {info.row.original?.customer_id ? (
                      <ToolTipComponent
                        text={CustomerTableCard(info.row.original)}
                        height={"120px"}
                        placement={"right"}
                        style={{ minWidth: "230px" }}
                      >
                        <p
                          onClick={(e) => {
                            handleCustomerNameClick(e, info.row.original.customer_id);
                          }}
                          className="overflow-hidden text-ellipsis"
                          style={
                            isMyTaskCompleted(info.row.original.status, info.row.original.id)
                              ? { color: "grey" }
                              : { color: "#2999BC" }
                          }
                        >
                          <HighlightedParagraph paragraph={value} searchTerm={globalFilter} />
                        </p>
                      </ToolTipComponent>
                    ) : (
                      <p className="">{value}</p>
                    )}
                  </div>
                </div>
              );
            }

            if (header.value === "assigned_to") {
              const { assigned_to } = info.row.original;

              return (
                <div className="flex">
                  {assigned_to?.map((person, index) => {
                    if (index < 3) {
                      // Render the first 3 persons
                      // const { initials, background } = getInitials(person);
                      const initials = getInitials(person?.name);
                      return (
                        <span key={index} className="mr-[-5px] flex items-center justify-center ">
                          <AvatarName
                            name={initials}
                            size="medium"
                            bgColor={
                              isMyTaskCompleted(info.row.original.status, info.row.original.id) ? "grey" : person?.c_key
                            }
                          />
                        </span>
                      );
                    } else if (index === 3) {
                      // Render the count of remaining persons
                      const remainingCount = assigned_to.length - 3;
                      if (remainingCount > 0) {
                        return (
                          <span
                            key="remaining-count"
                            className="ml-2 flex items-center justify-center rounded-full bg-gray-500 text-white"
                            style={{
                              width: "26px",
                              height: "26px",
                              fontSize: "12px",
                            }}
                          >
                            +{remainingCount}
                          </span>
                        );
                      }
                    }
                    return null;
                  })}
                </div>
              );
            }
            if (header.value === "status") {
              const { status, status_colour_code, sub_tasks } = info.row.original;
              return (
                <div className="flex items-center w-full h-full">
                  <p
                    className="flex grow items-center justify-center px-7 py-[9px] w-full text-white"
                    style={{
                      backgroundColor: status_colour_code,
                      color: "white",
                      opacity: isMyTaskCompleted(info.row.original.status, info.row.original.id) ? 0.5 : 1,
                    }}
                  >
                    <HighlightedParagraph paragraph={getTitleCase(status)} searchTerm={globalFilter} />
                  </p>
                </div>
              );
            }

            if (header.value === "priority") {
              const { priority, priority_colour_code } = info.row.original;
              return (
                <div
                  className="rounded-full w-6 h-6 flex items-center justify-start  text-[12px]"
                  style={{
                    backgroundColor: priority_colour_code && `${priority_colour_code}1A`, // Add alpha manually for transparency if supported (e.g., `#FCB72E1A` for 10% opacity)
                    color: priority_colour_code,
                    borderColor: priority_colour_code,
                  }}
                >
                  <span
                    style={isMyTaskCompleted(info.row.original.status, info.row.original.id) ? { color: "grey" } : {}}
                    className="flex items-center justify-center gap-x-1"
                  >
                    {isMyTaskCompleted(info.row.original.status, info.row.original.id) ? (
                      <span className="opacity-50">{PriortyOptions[priority]}</span>
                    ) : (
                      <HighlightedParagraph paragraph={PriortyOptions[priority]} searchTerm={globalFilter} />
                    )}
                    <HighlightedParagraph paragraph={getTitleCase(priority)} searchTerm={globalFilter} />
                  </span>
                </div>
              );
            }

            if (header.type === "tags") {
              const newKey = header.value;
              const { [newKey]: value } = info.row.original;
              return (
                <div className="flex items-center">
                  {Array.isArray(value) && value?.length > 0 ? (
                    <ToolTipComponent
                      text={
                        <div className="flex items-start justify-center flex-col gap-y-2 p-1">
                          {value?.map((tag, index) => (
                            <span
                              style={{
                                backgroundColor: tag?.color_code,
                                padding: "5px 10px",
                                borderRadius: "5px",
                                color: "white",
                              }}
                              key={index}
                            >
                              <HighlightedParagraph paragraph={tag?.label} searchTerm={globalFilter} />
                            </span>
                          ))}
                        </div>
                      }
                      textOnly
                    >
                      <div className="flex gap-x-1 items-center">
                        <Tagslength className="fill-primary" />
                        <span className="text-primary">({value.length})</span>
                      </div>
                    </ToolTipComponent>
                  ) : (
                    <NullTag />
                  )}
                </div>
              );
            }

            if (header.value === "activity") {
              const rowKey = `${info.row.original?.id}-${popupItemId}`;
              if (!info.row.original?.sub_tasks) {
                return <p></p>;
              }

              return (
                <div key={rowKey}>
                  <div onClick={(e) => handleMouseEnterDebounced(e, info.row.original)}>
                    <p className="">
                      <ActivityIcon />
                    </p>
                  </div>

                  {popupItemId === (editData?.id || info.row.original?.id) && isPopupOpenActivity && (
                    <>
                      <CustomerEditTaskActivity
                        open={popupItemId === (editData?.id || info.row.original?.id) && isPopupOpenActivity}
                        activityid={info.row.original?.id}
                        cross
                        type="Task"
                        onClose={handleClosed}
                        handleNotification={handleClosed}
                        item={info.row.original}
                      />
                    </>
                  )}
                </div>
              );
            }

            if (header.value === "end_date") {
              const { start_date, end_date } = info.row.original;

              const startCompact = formatUTCToCompact(start_date); // 20260224
              const endCompact = formatUTCToCompact(end_date);

              const startYearMonth = startCompact?.slice(0, 6); // 202602
              const endYearMonth = endCompact?.slice(0, 6);

              const local_start_date = getUserDateTime(start_date, "toLocal", "dayAndMonth");
              const local_end_date = getUserDateTime(end_date, "toLocal", "dateOnly");

              const start_date_only = getUserDateTime(start_date, "toLocal", "dateOnly");
              const end_date_only = getUserDateTime(end_date, "toLocal", "dateOnly");

              const isCompleted = isMyTaskCompleted(info.row.original.status, info.row.original.id);

              let content;

              // ✅ 1. Full date same (YYYYMMDD)
              if (startCompact === endCompact) {
                content = <HighlightedParagraph paragraph={local_end_date} searchTerm={globalFilter} />;
              }
              // ✅ 2. Same year & month (YYYYMM)
              else if (startYearMonth === endYearMonth) {
                content = (
                  <>
                    <HighlightedParagraph paragraph={local_start_date} searchTerm={globalFilter} />
                    <span className="mx-1">-</span>
                    <HighlightedParagraph paragraph={local_end_date} searchTerm={globalFilter} />
                  </>
                );
              }
              // ✅ 3. Completely different
              else {
                content = (
                  <>
                    <HighlightedParagraph paragraph={start_date_only} searchTerm={globalFilter} />
                    <span className="mx-1">-</span>
                    <HighlightedParagraph paragraph={end_date_only} searchTerm={globalFilter} />
                  </>
                );
              }

              return (
                <div className="flex justify-between items-center text-sm">
                  <span style={{ color: isCompleted ? "grey" : "black" }} className="flex items-center">
                    {content}
                  </span>
                </div>
              );
            }
            if (header.value === "created_at" || header.value === "updated_at") {
              const { created_at, updated_at } = info.row.original;

              return (
                <div className="flex justify-between items-center text-sm">
                  <p
                    style={
                      isMyTaskCompleted(info.row.original.status, info.row.original.id)
                        ? { color: "grey" }
                        : { color: "black" }
                    }
                  >
                    <HighlightedParagraph
                      paragraph={
                        header.value === "created_at" ? getUserDateTime(created_at) : getUserDateTime(updated_at)
                      }
                      searchTerm={globalFilter}
                    />
                  </p>
                </div>
              );
            }

            if (header.type === "date") {
              const value = info.getValue();
              const { is_recurrence } = info.row.original;

              return (
                <div className="flex justify-between items-center ">
                  <p
                    style={
                      isMyTaskCompleted(info.row.original.status, info.row.original.id)
                        ? { color: "grey", textAlign: getTextAlignment(header?.type) }
                        : { textAlign: getTextAlignment(header?.type) }
                    }
                  >
                    <HighlightedParagraph paragraph={formatToDDMMMYYYY(value)} searchTerm={globalFilter} />
                  </p>
                </div>
              );
            }

            if (header.value === "customer_display_name") {
              return (
                <p
                  className=""
                  style={isMyTaskCompleted(info.row.original.status, info.row.original.id) ? { color: "grey" } : {}}
                >
                  <HighlightedParagraph paragraph={info.getValue()} searchTerm={globalFilter} />
                </p>
              );
            }
            if (header.value === "subject") {
              const {
                subject,
                sub_tasks,
                category_id,
                checklists,
                is_recurrence,
                status,
                linked_to,
                attachments,
                parent_task_id,
              } = info.row.original;
              const rowId = info.row.id;

              return (
                <div
                  className="flex items-center justify-between gap-x-2 mr-2 w-full "
                  style={isMyTaskCompleted(info.row.original.status, info.row.original.id) ? { color: "grey" } : {}}
                >
                  <span className="flex items-center justify-start gap-x-1 min-w-0 grow">
                    {" "}
                    {/* <p className={`${sub_tasks ? "" : "truncate whitespace-nowrap overflow-hidden text-ellipsis"}`}> */}
                    {/* {sub_tasks?.length > 0 && (
                      <div onClick={(e) => toggleSubtaskExpanded(e, info.row.id)} className="cursor-pointer">
                        {subtaskExpanded[info.row.id] ? <SubTaskExpanded /> : <SubTaskNotExpanded />}
                      </div>
                    )} */}
                    <div className="flex min-w-0">
                      <p className="flex-1 min-w-0 truncate">
                        <HighlightedParagraph className="truncate" paragraph={subject} searchTerm={globalFilter} />
                      </p>
                    </div>
                    {sub_tasks?.length > 0 && (
                      <div
                        className={`flex group px-1 items-center rounded-[4px] ${subtaskExpanded[info.row.id] ? "bg-primary text-white" : "hover:text-primary hover:bg-primary-hover"} `}
                        onClick={(e) => {
                          toggleSubtaskExpanded(e, info.row.id);
                          setParentTaskData(info.row.original);
                        }}
                        role="button"
                        tabIndex={0}
                        onKeyDown={(e) => {
                          if (e.key === "Enter" || e.key === " ") toggleSubtaskExpanded(e, info.row.id);
                        }}
                      >
                        <ToolTipComponent disableInteractive className="group" text="Subtasks" darkMode>
                          {subtaskExpanded[info.row.id] ? (
                            <div className="flex items-center h-5 w-5 justify-center rounded-md ">
                              <SubTaskIconOpen />
                            </div>
                          ) : (
                            <div className="flex items-center h-5 w-5 justify-center">
                              <SubTaskIconClosed />
                            </div>
                          )}
                        </ToolTipComponent>

                        <span
                          className={`${subtaskExpanded[info.row.id] ? "bg-primary text-white" : "hover:text-primary hover:bg-primary-hover"} font-inter text-[12px] font-normal leading-normal ml-1`}
                        >
                          ({sub_tasks?.length})
                        </span>
                      </div>
                    )}
                  </span>

                  <span className="flex items-center justify-start gap-x-1">
                    {Boolean(linked_to) && (
                      <ToolTipComponent disableInteractive className="group delete-button" text="Link" darkMode>
                        <div
                          className="border rounded-md border-[#898989] flex items-center justify-center group delete-button w-6 h-6 bg-white hover:bg-primary-hover"
                          onClick={(e) => {
                            e.stopPropagation();
                            handleActions(info.row.original, "link");
                          }}
                        >
                          <LinkTask className="fill-[#898989]" />
                        </div>
                      </ToolTipComponent>
                    )}

                    <ToolTipComponent disableInteractive className="group delete-button" text="Duplicate" darkMode>
                      <div
                        className="border rounded-md border-[#898989] flex items-center justify-center group delete-button w-6 h-6 bg-white hover:bg-primary-hover"
                        onClick={(e) => {
                          e.stopPropagation();
                          handleActions(info.row.original, "duplicate");
                        }}
                      >
                        <DuplicateTask />
                      </div>
                    </ToolTipComponent>

                    <ToolTipComponent disableInteractive className="group delete-button" text="Copy To" darkMode>
                      <div
                        className="border rounded-md border-[#898989] flex items-center justify-center group delete-button w-6 h-6 bg-white hover:bg-primary-hover"
                        onClick={(e) => {
                          e.stopPropagation();
                          handleActions(info.row.original, "copyTo");
                        }}
                      >
                        <CopyToTask />
                      </div>
                    </ToolTipComponent>

                    {status !== "completed" && !parent_task_id && (
                      <ToolTipComponent disableInteractive className="group delete-button" text="Add Sub Task" darkMode>
                        <div className="border border-[#898989] rounded-md flex items-center justify-center group delete-button w-6 h-6 bg-white hover:bg-primary-hover">
                          <AddSubTask
                            // className="group-hover:fill-primary fill-[#969BA9]"
                            onClick={(e) => {
                              e.stopPropagation();
                              handleSubTaskOpen(info.row.original, true);
                            }}
                          />
                        </div>
                      </ToolTipComponent>
                    )}
                    {Boolean(attachments?.length) && (
                      <ToolTipComponent disableInteractive className="group" text="Attachments" darkMode>
                        <div
                          onClick={(e) => {
                            e.stopPropagation();
                            handleActions(info.row.original, "attachments");
                          }}
                          className="border rounded-md border-primary flex items-center justify-center group w-6 h-6 bg-white hover:bg-primary-hover"
                        >
                          <AtachmentTaskTable className="fill-primary" />
                        </div>
                      </ToolTipComponent>
                    )}
                    {Boolean(is_recurrence) && (
                      <ToolTipComponent disableInteractive text="Recurring" darkMode>
                        <div
                          className="border rounded-md border-primary flex items-center justify-center w-6 h-6 bg-white hover:bg-primary-hover"
                          onClick={(e) => {
                            e.stopPropagation();
                            handleActions(info.row.original, "recurring");
                          }}
                        >
                          <ReccurenceTaskIcons className="fill-primary" />
                        </div>
                      </ToolTipComponent>
                    )}

                    {category_id === "project" && checklists?.length > 0 && (
                      <button
                        onClick={(e) => {
                          handleProjectIconClick(e, info.row.original);
                        }}
                      >
                        <ProjectIcon />
                      </button>
                    )}
                  </span>
                </div>
              );
            }

            if (header.value === "notes") {
              return (
                <p onClick={() => handleViewNotesClick(info.row.original)}>
                  <div className="flex items-center gap-1 min-w-fit">
                    <ToolTipComponent disableInteractive text="View Notes" textOnly>
                      <ViewNotes className="hover:fill-[#1D4469] fill-[#969BA9]" />
                    </ToolTipComponent>
                    {value > 0 && <span style={{ fontSize: "12px", color: "#666" }}>({value})</span>}
                  </div>
                </p>
              );
            }

            if (header.value === "attachments") {
              const value = info.getValue();
              return (
                <div className="flex items-center justify-center w-full mr-3">
                  {value?.length > 0 && (
                    <div className="flex items-center justify-center gap-x-2 text-primary text-center">
                      <AtachmentTaskTable className="fill-primary" /> ({value.length})
                    </div>
                  )}
                </div>
              );
            }
            if (header.value === "project_id") {
              const { project_name } = info.row.original;

              return <HighlightedParagraph paragraph={project_name} searchTerm={globalFilter} />;
            }
            if (header.value === "service_id") {
              const { service_name } = info.row.original;
              return <HighlightedParagraph paragraph={service_name} searchTerm={globalFilter} />;
            }

            // there is dropdown/multiselect options
            if (header.type === "dropdown") {
              const value = info.row.original[header.value];

              return (
                <p className="rounded flex gap-1 w-fit  text-ellipsis overflow-hidden">
                  <span
                    style={{
                      backgroundColor: value?.color_code || value?.color || "",
                      color: value?.color_code || value?.color ? "#ffffff" : "var(--color-primary-text)",
                    }}
                    className={`px-2 py-1 rounded text-ellipsis overflow-hidden w-fit `}
                  >
                    <HighlightedParagraph
                      paragraph={value?.label ? value?.label : value ? value : ""}
                      searchTerm={globalFilter}
                    />
                  </span>
                </p>
              );
            }
            if (header.type === "multiselect") {
              const value = info.row.original[header.value];

              return (
                <p className="rounded flex gap-1 w-fit  text-ellipsis overflow-hidden">
                  {value?.length ? (
                    value?.map((item) => {
                      return (
                        <span
                          style={{ backgroundColor: item?.color_code || item?.code || "black", color: "white" }}
                          className={`px-2 py-1 rounded text-ellipsis overflow-hidden w-fit `}
                        >
                          <HighlightedParagraph paragraph={item?.label} searchTerm={globalFilter} />
                        </span>
                      );
                    })
                  ) : (
                    <>-</>
                  )}
                </p>
              );
            }

            if (header.type === "person") {
              const value = info.row.original[header?.value];

              return (
                <p className="rounded flex gap-1 w-fit  text-ellipsis overflow-hidden">
                  {value?.length ? (
                    value?.map((item) => {
                      const initials = getInitials(item?.name);

                      return (
                        <ToolTipComponent
                          disableInteractive
                          className="group delete-button"
                          text={
                            <div className="w-full h-full flex flex-col items-start justify-center gap-y-1">
                              <p className="text-sm font-medium text-white">{item?.name}</p>
                              <p className="text-sm font-medium text-white">{item?.email}</p>
                            </div>
                          }
                          darkMode
                        >
                          <div>
                            <AvatarName
                              name={initials}
                              size="medium"
                              bgColor={"grey"}
                              textColor={"#6b7280"}
                              borderColor={"#ABABAC"}
                            />
                          </div>
                        </ToolTipComponent>
                      );
                    })
                  ) : (
                    <>-</>
                  )}
                </p>
              );
            }

            if (header.type === "multi_person") {
              const value = info.row.original[header.value];

              return (
                <p className="rounded flex gap-1 w-fit  text-ellipsis overflow-hidden">
                  {value?.length ? (
                    Array.isArray(value) &&
                    value?.map((item) => {
                      const initials = getInitials(item?.name);

                      return (
                        <ToolTipComponent
                          disableInteractive
                          className="group delete-button"
                          text={
                            <div className="w-full h-full flex flex-col items-start justify-center gap-y-1">
                              <p className="text-sm font-medium text-white">{item?.name}</p>
                              <p className="text-sm font-medium text-white">{item?.email}</p>
                            </div>
                          }
                          darkMode
                        >
                          <div>
                            <AvatarName
                              name={initials}
                              size="medium"
                              bgColor={"grey"}
                              textColor={"#FFFFFF"}
                              borderColor={"#ABABAC"}
                            />
                          </div>
                        </ToolTipComponent>
                      );
                    })
                  ) : (
                    <>-</>
                  )}
                </p>
              );
            }
            if (header.type === "text") {
              const value = info.row.original[header.value];
              return (
                <div className="flex items-center">
                  <p className="text-sm">{value}</p>
                </div>
              );
            }

            try {
              const parsedValue = typeof value === "string" ? safeJsonParse(value) : value;
              if (Array.isArray(parsedValue)) {
                return (
                  <p className="rounded flex gap-1 w-fit  text-ellipsis overflow-hidden">
                    {parsedValue?.map((item) => {
                      return (
                        <span
                          style={{ backgroundColor: item?.color_code || item?.code || "black", color: "white" }}
                          className={`px-2 py-1 rounded text-ellipsis overflow-hidden w-fit `}
                        >
                          {item?.value}
                        </span>
                      );
                    })}
                  </p>
                );
              }

              if (typeof parsedValue === "object" && parsedValue?.value) {
                const rgbaColor =
                  parsedValue?.color_code || parsedValue?.code ? `${parsedValue.color_code}99` : undefined;
                return (
                  <p
                    className={`${rgbaColor && "px-2 py-1"} rounded  text-ellipsis overflow-hidden w-fit`}
                    style={{
                      backgroundColor: rgbaColor,
                      color: rgbaColor ? "white" : "black",
                    }}
                  >
                    {parsedValue.value}
                  </p>
                );
              }
            } catch (error) {}

            return (
              <HighlightedParagraph
                paragraph={value}
                searchTerm={globalFilter}
                className={`w-full text-ellipsis overflow-hidden truncate `}
                // style={{ textAlign: getTextAlignment(header?.type) }}
                style={
                  isMyTaskCompleted(info.row.original.status, info.row.original.id)
                    ? { color: "grey", textAlign: getTextAlignment(header?.type) }
                    : { textAlign: getTextAlignment(header?.type) }
                }
              />
            );
          },
        })) || [];

    const actionColumns = [
      {
        accessorKey: "is_deletable",
        header: "",

        meta: { position: "left" },
        enableFiltering: false,
        enableColumnFilter: false,
        cell: (info) => {
          return (
            <div className="text-left flex justify-center items-center">
              {info.row.original.created_by_user_id === getUserId() ? (
                <>
                  <button
                    className="text-F84545 text-15 text-left delete-button"
                    onClick={(e) => handleDeleteConfirmation(e, info.row.original)}
                  >
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="12" viewBox="0 0 19 18" fill="none">
                      <path
                        d="M3.04017 5L3.9258 15.6912C3.98927 16.4622 4.646 17.0667 5.41993 17.0667H13.5801C14.354 17.0667 15.0108 16.4622 15.0742 15.6912L15.9598 5H3.04017ZM6.99953 15.0667C6.7378 15.0667 6.5176 14.8631 6.501 14.5979L6.001 6.53123C5.9839 6.25537 6.19337 6.01807 6.46877 6.00097C6.7544 5.98093 6.98147 6.19287 6.99903 6.46873L7.49903 14.5354C7.51673 14.8211 7.2907 15.0667 6.99953 15.0667ZM10 14.5667C10 14.843 9.77637 15.0667 9.5 15.0667C9.22363 15.0667 9 14.843 9 14.5667V6.5C9 6.22363 9.22363 6 9.5 6C9.77637 6 10 6.22363 10 6.5V14.5667ZM12.999 6.53127L12.499 14.5979C12.4826 14.8604 12.2638 15.0791 11.9687 15.0657C11.6933 15.0486 11.4839 14.8113 11.501 14.5354L12.001 6.46877C12.0181 6.1929 12.2598 5.9922 12.5312 6.001C12.8066 6.0181 13.0161 6.2554 12.999 6.53127Z"
                        fill="#F84545"
                      />
                      <path
                        d="M16 2H13V1.5C13 0.672867 12.3271 0 11.5 0H7.5C6.67287 0 6 0.672867 6 1.5V2H3C2.4477 2 2 2.4477 2 3C2 3.55223 2.4477 4 3 4C7.59887 4 11.4013 4 16 4C16.5523 4 17 3.55223 17 3C17 2.4477 16.5523 2 16 2ZM12 2H7V1.5C7 1.22413 7.22413 1 7.5 1H11.5C11.7759 1 12 1.22413 12 1.5V2Z"
                        fill="#F84545"
                      />
                    </svg>
                  </button>
                </>
              ) : null}
            </div>
          );
        },
      },
    ];

    return [...staticColumn, ...dynamicColumns, ...actionColumns];
  }, [
    dynamicHeaders,
    templateId,
    taskHeaderCongiguration,
    grouping,
    multiData,
    globalFilter,
    isAdvancedFilterOpen,
    viewMode,
    subtaskExpanded,
  ]);

  const PriortyOptions = {
    null: <NullPriority />,
    High: <HighPriority />,
    Medium: <MediumPriority />,
    Low: <LowPriority />,
    urgent: <UrgentPriority />,
  };

  const [columnVisibility, setColumnVisibility] = useState({});

  const [deleteTask] = useDeleteTaskMutation();

  const [deleteProject] = useDeleteProjectMutation();

  const handleDeleteConfirmation = (e, data) => {
    e.stopPropagation();
    setDeleteData(data);
    setShowConfirmation(data?.category_id);
  };

  const handleDeleteTask = async (selection, data) => {
    setShowConfirmation(false);

    try {
      let response;

      if (data?.is_project) {
        response = await deleteProject({ token: token?.token, data }).unwrap();
      } else {
        response = await deleteTask({
          token: token?.token,
          data,
          delete_options: selection,
        }).unwrap();
      }

      if (response?.success) {
        dispatch(pushAlert({ type: "success", message: response?.message || response?.error, visible: true }));
        refetchCustomerData();
      } else if (response?.error) {
        dispatch(pushAlert({ type: "danger", message: response?.error, visible: true }));
      }
    } catch (error) {
      dispatch(pushAlert({ type: "danger", message: error, visible: true }));
    }
  };
  const {
    data: customerTableALL,
    isLoading,
    isError: bodyError,
    isFetching,
    refetch: refetchCustomerDataOnly,
  } = useFetchCustomerTaskPodTableDataQuery(
    {
      customer_id: customerId,
      company_id: companyId,
      pagination: `${customerTablePagination}&per_page=1000`,
      paginate: true,
      quiFilter: quiFilter?.value,
      token: token,
      assign_id: userDataId?.id,
      // filter_tab: activeTab.slice(1),
      group_by_fields: newPayload,
      task_pod: taskpodPayload?.value,
      category_filter: templateId === "projects" ? "all_project" : templateId,
      visibility_status: activeTab,
    },
    {
      skip: templateId !== "projects",
    }
  );

  const TaskFilterData = () => {
    if (listView === "kanban") {
      fetchKanbanData();
    } else {
      handleRefetchGetAllTasks();
    }
  };

  function getHiddenFields(obj) {
    const hidden_fields = [];

    for (const [key, value] of Object.entries(obj)) {
      if (value !== true) hidden_fields.push(key);
      else;
    }

    return hidden_fields;
  }

  const refetchCustomerData = useCallback(() => {
    freshPollingCounter.current = 0;
    if (templateId === "projects") return;
    TaskFilterData();
  }, [TaskFilterData, freshPollingCounter]);

  const refetchPollingData = () => {
    freshPollingCounter.current += 1;
    if (templateId === "projects") return;
    TaskFilterData();
  };

  usePollingWithReset(refetchPollingData, [customerTableALL], 10000, true, "Task Table");

  const memoizeDynamicData = useMemo(() => {
    if (templateId === "projects") {
      return customerTableALL?.data || [];
    }

    return fetchGetAllTasks?.data || [];
  }, [customerTableALL, fetchGetAllTasks, fetchGetAllTasks?.data, templateId, dashBoardFilterValue]);

  const [originalPageSize, setOriginalPageSize] = useState(null);

  const formatEndDate = useFormatDate();

  const CircleSpan = styled("span")({
    display: "inline-block",
    width: "24px",
    height: "24px",
    borderRadius: "50%",
    backgroundColor: "#ccc",
    textAlign: "center",
    lineHeight: "24px",
    fontSize: "12px",
    fontWeight: "bold",
    color: "#fff",
  });

  useEffect(() => {
    if (customerTableALL) {
      if (!Array.isArray(customerTableALL?.data)) {
        setCustomer(Object.keys(customerTableALL?.data));
      } else {
        const { data, ...restData } = customerTableALL;
        setCustomer(data);
        setCustomerMainData(data);
        setInitialFilter(restData);
        setTotalData(customerTableALL?.total);
        setLoading(false);
        setCompletedTasks({});
      }
    }
  }, [customerTableALL, customerTablePagination]);

  useEffect(() => {
    if (taskFormSubmit?.tasks?.data?.data) {
      refetchCustomerData();
    }
  }, [taskFormSubmit?.tasks?.data?.data, activeTab]);

  const [fetchPersonInTable, { data: personTableData }] = useLazyFetchPersonInTableQuery();

  const fetchPersonData = (data) => fetchPersonInTable({ token: token?.token, data, companyId: companyId });

  const [updateCustomerTaskPodTableData, { CustomerDropLoad, CustomerDroperror }] =
    useUpdateCustomerTaskPodTableDataMutation();

  const [updateTaskCompletion, { isFetching: isTaskCompletionUpdating }] = useUpdateTaskCompletionMutation();

  //for dynamic form
  const handleNavigate = (customer_id, data, isTaskProject, openSubTask, isRecurrenceModalOpen) => {
    const isSubtask = data?.parent_task_id !== null;
    const isParent = data?.parent_task_id === null;
    const isProject = data?.is_project;
    if (isParent) setSeriesRecurModel(isRecurrenceModalOpen);

    if (isProject) {
      setOpenAddProject("edit");
      setEditData(data);
    } else {
      setIsPopupOpen(true);
      setSubTaskData(null);
      setEditData({ ...data, parentName: isTaskProject });
    }
  };

  const handleNavigateParent = () => {
    if (parentTaskData) {
      setIsPopupOpen(true);
      setEditData(parentTaskData);
    }
  };

  const handleActions = (data, type) => {
    if (!data) return;

    const updated = {
      ...data,
      isDuplicateTask: type === "duplicate",
      isCopyToTask: type === "copyTo",
      isLinkTask: type === "link",
      recurModal: type === "recurring",
      isAttachment: type === "attachments",
    };

    setEditData(updated);
  };

  useEffect(() => {
    if (
      editData?.isDuplicateTask ||
      editData?.isCopyToTask ||
      editData?.isLinkTask ||
      editData?.recurModal ||
      editData?.isAttachment
    ) {
      setIsPopupOpen(true);
    }
  }, [
    editData?.isDuplicateTask,
    editData?.isCopyToTask,
    editData?.isLinkTask,
    editData?.recurModal,
    editData?.isAttachment,
  ]);

  useEffect(() => {
    dispatch(getUserTokeData());
  }, [location]);

  const handleTabClick = (tab) => {
    setActiveTab(tab);
    setResetPageIndex(true);
    searchParams.set("activeTab", `${tab}`);
    setSearchParams(searchParams);
  };

  const openPopup = useCallback(
    (args) => {
      if (templateId === "projects") {
        setOpenAddProject("add");
        setProjectFormData(null);
      } else {
        setIsPopupOpen(args || true);
        setSubTaskData(null);
      }

      dispatch(getUserTokeData());
    },
    [templateId]
  );

  useEffect(() => {
    if (!isPopupOpen) {
      setIsHovered(false);
    }
  }, [isPopupOpen]);

  const closePopup = () => {
    setIsEditPopupOpen(false);
    setIsPopupOpen(false);
    setEditData();
    setOpenSubTaskDrawer(false);
  };

  const [taskExpand, setTaskExpand] = useState(false);
  const TaskExpand = () => setTaskExpand(!taskExpand);

  useEffect(() => {
    if (refreshKey) {
      refetchCustomerData();
    }
  }, [refreshKey]);

  const handleEditFields = (selection) => {
    const Selectedaccordfield = { ...editData, selection };
    setEditData(Selectedaccordfield);
    if (selection === "entire") {
      setIsPopupOpen(true);
      setEditData({ ...Selectedaccordfield, recurModal: true });
    } else {
      setEditData({ ...Selectedaccordfield, recurModal: false });
      setIsPopupOpen(true);
    }
  };

  const handleSaveModal = (selection) => {
    setEditData();
    handleEditFields(selection);
    setSeriesRecurModel(false);
  };

  const handleToggle = (state) => {
    addQueryParam("listView", state);
  };

  const {
    refetch: refetchGetAllTemplate,
    data: GetAlltemplates,
    isLoading: isGetAllTemplatesLoading,
    isError: isGetAllTemplatesError,
    isSuccess: isGetAllTemplatesSuccess,
    error: GetAllTemplatesError,
  } = useFetchAllTemplateQuery({ myActivities: hasMyActivities });

  useEffect(() => {
    if (GetAlltemplates) {
      const convertedData = Array.isArray(GetAlltemplates?.data)
        ? GetAlltemplates?.data?.map((item) => ({
            // component: "TaskModule",
            label: item?.template_name,
            // module_uuid: item.id,
            value: item.id,
          }))
        : [];

      if (hasMyActivities === 0) {
        const ListAssignment = assignmentList?.map((item) => ({
          // component: "TaskModule",
          label: item?.label,
          value: item?.id, // job == "id" Projects == "projects"
        }));
        setSubRoutingData(ListAssignment);
      } else {
        setSubRoutingData(convertedData);
      }
    }

    refetchGetAllTemplate();
  }, [GetAlltemplates?.data, isGetAllTemplatesError, isGetAllTemplatesLoading, GetAllTemplatesError, templateId]);

  // Step 1: convert array of fields to visibility map
  function convertToVisibilityMap(fields) {
    const result = {};
    for (const field of fields) {
      if (field.is_visible === 1) {
        result[field.value] = true;
      }
    }
    return result;
  }
  function reorderArray(arr, sourceIndex, targetIndex) {
    // Make a shallow copy
    const newArr = [...arr];

    // Handle invalid indices
    if (sourceIndex < 0 || targetIndex < 0 || sourceIndex >= newArr.length || targetIndex >= newArr.length) {
      return newArr;
    }

    // Move the element
    const [moved] = newArr.splice(sourceIndex, 1);
    newArr.splice(targetIndex, 0, moved);

    return newArr; // ✅ returns an array of strings
  }

  const handleReorderFields = (sourceIndex, targetIndex) => {
    const reOrderingColumn = reorderArray(columnOrder, sourceIndex, targetIndex);
    if (reOrderingColumn) {
      setColumnOrder(reOrderingColumn);
    }
  };

  const handleFieldVisibility = (fieldName) => {
    const visibilty = toggleVisibility(columnVisibility || {}, fieldName);
    setColumnVisibility(visibilty);
    setColumnOrder(Object.keys(visibilty).filter((key) => visibilty[key] === true));
  };
  const [PostMetaData] = usePostApiMutation();

  const handlePostMeta = () => {
    PostMetaData({
      url: `${NODE_URL}template/${templateId}/meta?is_company_level=${!customerTask ? "true" : "false"}`,
      data: {
        field_management: {
          field_visibility: [columnVisibility],
          field_order: columnOrder,
        },
      },
    });
    setIsManageFieldOpen(false);
  };

  //top toggle new buttons
  const ViewData = () => {
    return (
      <div className={`flex items-center justify-end`}>
        <div
          className={`flex justify-center items-center  border border-[#1313133d] rounded-full p-1  bg-[#F6F6F6]`}
          role="group"
        >
          <ToggleMultiSwitch
            options={[
              { label: <ListIcon fill={listView === "list" ? "#ffffff" : "#8E8E8E"} />, value: "list" },
              { label: <GridIcon fill={listView === "calendar" ? "#ffffff" : "#8E8E8E"} />, value: "calendar" },
              { label: <KanBanBoardSvg fill={listView === "kanban" ? "#ffffff" : "#8E8E8E"} />, value: "kanban" },
            ]}
            onToggle={handleToggle}
            defaultValue={listView}
            className="w-30 h-[27px] "
            paddingHorizontal="px-4"
          />
        </div>
      </div>
    );
  };

  //compact view switch button
  const CompactViewSwitchButton = () => {
    return (
      <div className={`flex items-center justify-end`}>
        <div
          className={`flex justify-center items-center  border border-[#1313133d] rounded-full p-1  bg-[#F6F6F6]`}
          role="group"
        >
          <ToggleMultiSwitch
            options={[
              {
                label: (
                  <div className="flex items-center justify-center gap-1">
                    <ListIcon fill={viewMode === "detailed" ? "#ffffff" : "#8E8E8E"} />
                    <span>{viewMode == "detailed" ? "Detailed" : ""}</span>
                  </div>
                ),
                value: "detailed",
              },
              {
                label: (
                  <div className="flex items-center justify-center gap-1">
                    <GridIcon fill={viewMode === "compact" ? "#ffffff" : "#8E8E8E"} />
                    <span>{viewMode == "compact" ? "Compact" : ""}</span>
                  </div>
                ),
                value: "compact",
              },
            ]}
            onToggle={() => {
              setViewMode((prev) => (prev === "detailed" ? "compact" : "detailed"));
            }}
            defaultValue={viewMode}
            className="w-30 h-[27px] "
            paddingHorizontal="px-4"
            addProp={viewMode}
          />
        </div>
      </div>
    );
  };

  const toggleDropdown = (headerId) => {
    setOpenDropdownId((prevId) => (prevId === headerId ? null : headerId));
  };

  useEffect(() => {
    if (templateId === "projects") {
      setDynamicHeaders(taskHeaderCongiguration?.data || []); //vinay
      return;
    }

    if (isDyanmicHeaderLoading) {
      dispatch(showLoader());
    } else {
      dispatch(hideLoader());
    }

    if (isDyanmicHeaderSuccess && dynamicHeaderValues?.status) {
      // dispatch(
      //   pushAlert({
      //     // message: dynamicHeaderValues?.message || "Section fields fetched successfully",
      //     type: "success",
      //     visible: true,
      //   })
      // );
      if (dynamicHeaderValues?.data) {
        setDynamicHeaders(dynamicHeaderValues?.data);
        const fitlerColumn = convertToVisibilityMap(dynamicHeaderValues?.data);
        const columnOrder = Object.keys(fitlerColumn).filter((key) => fitlerColumn[key] === true);

        const field_visibility = dynamicHeaderValues?.meta?.field_management?.field_visibility?.[0];
        const field_order = dynamicHeaderValues?.meta?.field_management?.field_order;

        let tempFieldOrder = [];
        let tempFieldVisibility = {};

        // Add new fields
        Object.keys(fitlerColumn).forEach((key) => {
          if (field_visibility && !field_visibility.hasOwnProperty(key)) {
            tempFieldOrder.push(key);
            tempFieldVisibility[key] = true;
          }
        });

        if ((field_visibility || field_order) && viewMode !== "compact") {
          // Remove fields that no longer exist in fitlerColumn
          const filteredVisibility = Object.fromEntries(
            Object.entries(field_visibility || {}).filter(([key]) => key in fitlerColumn)
          );
          const filteredOrder = (field_order || []).filter((key) => key in fitlerColumn);

          // Merge existing + new (additions only)
          setColumnVisibility({ ...filteredVisibility, ...tempFieldVisibility });
          setColumnOrder([...filteredOrder, ...tempFieldOrder]);
        } else {
          if (fitlerColumn) {
            setColumnVisibility(fitlerColumn);
            setColumnOrder(columnOrder);
          }
        }
      }
    }

    if (isDyanmicHeaderError) {
      dispatch(
        pushAlert({
          message: DyanmicHeaderError?.data?.message || "Failed to fetch section fields",
          type: "danger",
          visible: true,
        })
      );
    }
  }, [
    isDyanmicHeaderLoading,
    isDyanmicHeaderSuccess,
    isDyanmicHeaderError,
    dynamicHeaderValues?.data,
    templateId,
    taskHeaderCongiguration,
  ]);

  const closeAdvancedFilter = () => {
    setIsAdvancedFilterOpen(false);
  };

  useEffect(() => {
    if (isfetchGetAllTasksLoading) {
      dispatch(showLoader());
    } else {
      dispatch(hideLoader());
    }

    if (isfetchGetAllTasksSuccess && fetchGetAllTasks?.status) {
      dispatch(
        pushAlert({
          // message: fetchGetAllTasks?.message || "Tasks fetched successfully",
          type: "success",
          visible: true,
        })
      );

      if (fetchGetAllTasks?.data) {
        setDashBoardCountList(fetchGetAllTasks?.dashboard_count);
        setTaskIDList(fetchGetAllTasks?.data);
      }
    }

    if (isfetchGetAllTasksError) {
      dispatch(
        pushAlert({
          message: fetchGetAllTasksError?.data?.message || "Failed to fetch tasks",
          type: "danger",
          visible: true,
        })
      );
    }
  }, [
    isfetchGetAllTasksLoading,
    isfetchGetAllTasksSuccess,
    isfetchGetAllTasksError,
    fetchGetAllTasks?.data,
    fetchGetAllTasksError, // ✅ include this if you access it inside
  ]);

  const TaskNavbarQuickFilter = (option) => {
    setQuiFilter(option);
    setRefreshKey((prevKey) => prevKey + 1);
  };

  //make the static object routes and dynmic
  const transformedTemplates = GetAlltemplates?.data?.map((template) => ({
    label: template?.template_name,
    value: template?.template_name?.toLowerCase(), // or any custom value
    rightTab: String(template.section_count ?? 0),
    created_at: template?.created_at,
    created_by: template?.created_by,
    updated_at: template?.updated_at,
    updated_by: template?.updated_by,
    id: template?.id,
  }));

  const requiredLeadtypeList =
    (tabValue && tabValue === "to-do-hub") || location.pathname.includes("/my-activities/")
      ? transformedTemplates
      : transformedTemplates;

  const handleItemSearch = (e, columnKey) => {
    const value = e.target.value;
    setColumnSearchTerms(value);
  };

  let dashBoardIconsList = {
    all_task: <TaskIcon />,
    "not started": <NotStartedIcon />,
    "work in progress": <WorkInProgressIcon />,
    completed: <CompletedIcon />,
    cancelled: <CancelledIcon />,
    drop: <DropIcon />,
    "on hold": <HoldIcon />,
    default: <DefaultIcon />,
  };

  const handleDashBoardFilter = (value) => {
    if (value) {
      setDashBoardFilterValue(value);
    }
  };

  //to generate unique values for task page filter dropdowns
  function generateUniqueValuesForTaskPage(keys, opts = {}) {
    const { caseInsensitive = true } = opts;

    if (!Array.isArray(keys)) return [];

    const seen = new Set();
    const out = [];

    const norm = (v) => {
      if (v === null || v === undefined) return "";
      try {
        const s = String(v).trim();
        return caseInsensitive ? s.toLowerCase() : s;
      } catch {
        return "";
      }
    };

    const addIfNew = (uniqueKey, item) => {
      if (!uniqueKey) return false;
      if (!seen.has(uniqueKey)) {
        seen.add(uniqueKey);
        out.push(item);
        return true;
      }
      return false;
    };

    for (const entry of keys) {
      if (entry === null || entry === undefined) continue;

      // 1) Primitive entries (string / number / boolean)
      if (typeof entry === "string" || typeof entry === "number" || typeof entry === "boolean") {
        const key = norm(entry);
        addIfNew(key, entry);
        continue;
      }

      // 2) If entry is an array of objects -> consider each inner object's .value for uniqueness
      if (Array.isArray(entry)) {
        for (const inner of entry) {
          if (inner == null) continue;
          // prefer inner.value
          if (inner.value !== undefined && inner.value !== null) {
            const key = norm(inner.value);
            addIfNew(key, inner);
            continue;
          }
          // fallback: if inner has id use id
          if (inner.id !== undefined && inner.id !== null) {
            const key = norm(inner.id);
            addIfNew(key, inner);
            continue;
          }
          // fallback: stringify inner
          try {
            const key = norm(JSON.stringify(inner));
            addIfNew(key, inner);
          } catch {
            // ignore unparsable inner
          }
        }
        continue;
      }

      // 3) If entry is an object (not array)
      if (typeof entry === "object") {
        // prefer .id for uniqueness
        if (entry.id !== undefined && entry.id !== null) {
          const key = norm(entry.id);
          addIfNew(key, entry);
          continue;
        }

        // if it's a wrapper with .value which itself might be primitive / object / array
        if (Object.prototype.hasOwnProperty.call(entry, "value")) {
          const val = entry.value;

          // value primitive -> use it and keep wrapper entry
          if (typeof val === "string" || typeof val === "number" || typeof val === "boolean") {
            const key = norm(val);
            addIfNew(key, entry);
            continue;
          }

          // value is array -> handle inner items (push inner items)
          if (Array.isArray(val)) {
            for (const inner of val) {
              if (inner == null) continue;
              if (inner.value !== undefined && inner.value !== null) {
                const key = norm(inner.value);
                addIfNew(key, inner);
                continue;
              }
              if (inner.id !== undefined && inner.id !== null) {
                const key = norm(inner.id);
                addIfNew(key, inner);
                continue;
              }
              try {
                const key = norm(JSON.stringify(inner));
                addIfNew(key, inner);
              } catch {}
            }
            continue;
          }

          // value is object -> try value.id first, else value.value, else fallback to wrapper's id-like
          if (val && typeof val === "object") {
            if (val.id !== undefined && val.id !== null) {
              const key = norm(val.id);
              addIfNew(key, entry); // push wrapper entry (you can change to val if you prefer)
              continue;
            }
            if (val.value !== undefined && val.value !== null) {
              const key = norm(val.value);
              addIfNew(key, entry);
              continue;
            }
            // fallback: stringify inner object
            try {
              const key = norm(JSON.stringify(val));
              addIfNew(key, entry);
              continue;
            } catch {}
          }

          // fallback: wrapper entry without usable value
          try {
            const key = norm(JSON.stringify(entry));
            addIfNew(key, entry);
          } catch {}
          continue;
        }

        // 4) Generic object without id or value -> try to find a primitive property to use
        const primitiveProp = Object.keys(entry).find((k) => {
          const v = entry[k];
          return typeof v === "string" || typeof v === "number" || typeof v === "boolean";
        });
        if (primitiveProp) {
          const key = norm(entry[primitiveProp]);
          addIfNew(key, entry);
          continue;
        }

        // 5) Fallback: stringify whole object
        try {
          const key = norm(JSON.stringify(entry));
          addIfNew(key, entry);
        } catch {
          // ignore unstringifiable
        }
        continue;
      }

      // 6) Other types (symbol, function, etc.) - ignore or attempt stringify
      try {
        const key = norm(String(entry));
        addIfNew(key, entry);
      } catch {
        // ignore
      }
    }

    return out;
  }
  // to generate options from list
  function buildOptionsFromList(list, keys = "value") {
    if (!Array.isArray(list)) return [];

    const preferred = Array.isArray(keys) ? keys : [keys];

    const isPrimitive = (v) =>
      v === null || v === undefined ? false : ["string", "number", "boolean"].includes(typeof v);

    const getByPath = (obj, path) => {
      if (obj == null) return undefined;
      const parts = String(path).split(".");
      let cur = obj;
      for (const p of parts) {
        if (cur == null || typeof cur !== "object" || !Object.prototype.hasOwnProperty.call(cur, p)) {
          return undefined;
        }
        cur = cur[p];
      }
      return cur;
    };

    const pickFromObject = (obj) => {
      if (!obj || typeof obj !== "object") return null;
      const fallbacks = ["email", "label", "name", "value", "textForUrl", "url"];
      for (const f of fallbacks) {
        if (Object.prototype.hasOwnProperty.call(obj, f) && isPrimitive(obj[f])) return String(obj[f]);
      }
      // If obj.value is an object that contains a primitive field, try one level deeper
      if (obj.value && typeof obj.value === "object") {
        for (const f of fallbacks) {
          if (Object.prototype.hasOwnProperty.call(obj.value, f) && isPrimitive(obj.value[f])) {
            return String(obj.value[f]);
          }
        }
      }
      return null;
    };

    return list.map((entry) => {
      try {
        // Primitive -> use directly
        if (isPrimitive(entry)) {
          return { label: String(entry), value: entry };
        }

        // Object handling
        if (entry && typeof entry === "object") {
          // Try preferred keys (supports nested path like "value.textForUrl")
          for (const k of preferred) {
            if (!k) continue;
            const candidate = getByPath(entry, k);
            if (candidate === undefined || candidate === null) continue;

            if (isPrimitive(candidate)) {
              return { label: String(candidate), value: entry };
            }

            // candidate might be JSON-string (rare here) or object; if object try to pick primitive inside
            if (typeof candidate === "string") {
              // if string, still use as label (most pages want raw string)
              return { label: String(candidate), value: entry };
            }
            if (typeof candidate === "object") {
              const inner = pickFromObject(candidate);
              if (inner) return { label: inner, value: entry };
              // fallback to candidate as string
              try {
                return { label: String(candidate), value: entry };
              } catch {
                // continue to other keys/fallbacks
              }
            }
          }

          // If preferred keys didn't yield, try sensible fields inside the object itself
          const topPick = pickFromObject(entry);
          if (topPick) return { label: topPick, value: entry };

          // As last resort attempt to pick the first primitive property on the object
          for (const k of Object.keys(entry)) {
            const v = entry[k];
            if (isPrimitive(v)) return { label: String(v), value: entry };
          }

          // Ultimate fallback: stringify but keep it short to avoid huge labels
          try {
            const s = JSON.stringify(entry);
            const short = s.length > 80 ? s.slice(0, 77) + "..." : s;
            return { label: short, value: entry };
          } catch {
            return { label: String(entry), value: entry };
          }
        }

        // Any other type -> coerce to string
        return { label: String(entry), value: entry };
      } catch {
        // silent fallback to preserve original behaviour
        return { label: String(entry), value: entry };
      }
    });
  }

  return (
    <div className={` h-full`}>
      {freshPollingCounter.current === 0 && (isFetching || isLoading) && <Loader isOpen={isFetching || isLoading} />}
      <div className={`h-full flex flex-col ${customerTask ? "" : "px-4 py-2"}`}>
        {["list", "kanban"].includes(listView) && (
          <>
            <div className=" h-full">
              <CustomerReactTable
                headers={columns}
                body={memoizeDynamicData}
                narrowHeader
                TableDashboard={
                  listView === "list" &&
                  (templateId !== "projects" ? (
                    <TableDashboard
                      IconsList={dashBoardIconsList}
                      StatusList={dashBoardCountList}
                      handleDashBoardStatusFilter={handleDashBoardFilter}
                    />
                  ) : (
                    templateId === "projects" && (
                      <StatusDashboard menu_list={initialFilter?.dashboard_count} total_Count={totalData} />
                    )
                  ))
                }
                tableDetail={{
                  tableFilter: (
                    <>
                      {!moduleTaskId && (
                        <div className="flex items-center rounded-md gap-2 bg-white  grow min-w-0 overflow-auto scrollbar-hidden h-full text-red-500">
                          <InternalNavigation
                            items={subNavitems ?? subRoutingData}
                            subTabValue={templateId}
                            showOnlyActive

                            // onSelect={handleChangeMainLead}
                            // disableRouting //not to use Links
                          />
                        </div>
                      )}
                    </>
                  ),
                }}
                kanbanSearchIcon={true}
                columnSearchTerms={columnSearchTerms}
                setColumnSearchTerms={setColumnSearchTerms}
                ExtraFields={
                  <>
                    <div className={`min-w-0 grow p-1 mr-1 items-center justify-center group rounded-md flex `}>
                      <ToolTipComponent
                        darkMode
                        disableInteractive
                        text={allSubTaskOpen ? "Collapse All" : "Expand All"}
                        offset={"slightly-right"}
                      >
                        <button className="btn btn-success flex items-center gap-2" onClick={FilterTaskId}>
                          <span className=" text-sm font-normal">
                            {allSubTaskOpen ? (
                              <div className="flex items-center h-6 w-6 justify-center border rounded-sm hover:bg-[#CECECE4D]">
                                <SubTaskIconOpen />
                              </div>
                            ) : (
                              <div className="flex items-center h-6 w-6 justify-center border rounded-sm hover:bg-[#CECECE4D]">
                                <SubTaskIconClosed />
                              </div>
                            )}
                          </span>
                        </button>
                      </ToolTipComponent>
                    </div>

                    {!Boolean(templateId === "projects") && (
                      <div className="flex items-center justify-center ">
                        {/* {tableDetail?.addbuttonToday} */}

                        {templateId && (
                          <>
                            <div className="flex items-center justify-start gap-x-2">
                              {listView !== "kanban" && (
                                <ToDoActiveButton activeTab={activeTab} handleTabClick={handleTabClick} />
                              )}
                              <Fragment>
                                <div className={`flex`}>
                                  <QuickFilter
                                    options={[
                                      { id: 1, name: "All", value: "" },
                                      { id: 2, name: "Due Today", value: "due_today" },
                                      { id: 3, name: "Due This Week", value: "due_this_week" },
                                      { id: 4, name: "Due Next Week", value: "due_next_week" },
                                      { id: 5, name: "Created by me", value: "created_by_user" },
                                      { id: 6, name: "Assigned To me", value: "assigned_to_me" },
                                    ]}
                                    placeholder={<span className="text-848687">{"Quick Filter"}</span>}
                                    onSelect={TaskNavbarQuickFilter}
                                  />
                                  <span className="mx-1"></span>
                                </div>
                              </Fragment>
                            </div>

                            {/* {ViewData()} */}
                          </>
                        )}

                        <div className="flex gap-1 ">
                          {isSearchActive && (
                            <DebouncedInput
                              value={globalFilter ?? ""}
                              onChange={(value) => setGlobalFilter(String(value))}
                              className="px-2 h-8 font-lg shadow border border-block "
                              placeholder="Search"
                            />
                          )}
                        </div>
                      </div>
                    )}
                  </>
                }
                noMenuOpenList={["is_deletable", "select", "completionAction"]}
                handleRowEditClick={(e, rowData) => {
                  handleNavigate(null, rowData, templateId === "projects", false, true);
                }}
                // rowClickDisabled
                grouping={grouping}
                setGrouping={setGrouping}
                globalFilter={globalFilter}
                setGlobalFilter={setGlobalFilter}
                resetPageIndex={resetPageIndex}
                setResetPageIndex={setResetPageIndex}
                multiData={multiData}
                setMultiData={setMultiData}
                MainFields={
                  <div className="flex items-center justify-center gap-x-2">
                    {viewMode !== "compact" && !moduleTaskId && listView !== "kanban" && (
                      <ToolTipComponent darkMode text="Manage View">
                        <span
                          onClick={() => setIsManageFieldOpen(true)}
                          className="cursor-pointer  border-[#EBF2F6] rounded-full hover:bg-[#F6F6F6] hover:border-transparent"
                        >
                          <ManageIcon isActive={isManageFieldOpen} />
                        </span>
                      </ToolTipComponent>
                    )}

                    {!moduleTaskId && (
                      <ToolTipComponent darkMode text="Add">
                        <button
                          onClick={openPopup}
                          type="button"
                          className="flex items-center justify-center  h-[30px]  rounded-full"
                        >
                          <AddItemPlus isActive={isPopupOpen} isHovered={isHovered} />
                        </button>
                      </ToolTipComponent>
                    )}
                  </div>
                }
                apiStates={{
                  header: {
                    isLoading: templateId ? isDyanmicHeaderLoading : headerLoading,
                    isError: templateId ? isDyanmicHeaderError : headerError,
                  },
                  body: {
                    isLoading: templateId ? isfetchGetAllTasksLoading : isLoading,
                    isError: templateId ? isfetchGetAllTasksError : bodyError,
                  },
                }}
                alternateDivs={{
                  emptyData: (
                    <>
                      <div className="w-full h-full">
                        <div className="flex justify-center items-center flex-col space-y-2 h-full w-full">
                          {(() => {
                            switch (templateId) {
                              case "all":
                                return <NoALL className="h-[300px] w-[300px]" />; // ✅ new image for "all"
                              case "task":
                                return <NoTask className="h-[300px] w-[300px]" />;
                              case "deal":
                                return <NoTask className="h-[300px] w-[300px]" />;
                              case "lead":
                                return <NoTask className="h-[300px] w-[300px]" />;
                              case "project":
                                return <NoJobs />;
                              case "projects":
                                return <NoProject className="h-[300px] w-[300px]" />;
                              default:
                                return <SearchItemNotFound className="h-[300px] w-[300px]" />;
                            }
                          })()}
                          <span className="text-14 text-[#666666] text-sm font-400 font-poppins ">
                            {templateId === "all" ? (
                              "Nothing here yet. Create Task to get started." // ✅ Custom text for "all"
                            ) : templateId === "projects" ? (
                              "No projects found. you may add a new project." // ✅ Custom text for "project"
                            ) : (
                              <span>
                                No Task Available.
                                {!moduleTaskId && (
                                  <Button onClick={() => openPopup()} className="py-1 px-3 w-fit">
                                    {" "}
                                    + Add Task{" "}
                                  </Button>
                                )}
                              </span>
                            )}
                          </span>
                        </div>
                      </div>
                    </>
                  ),
                }}
                otherComponent={
                  <>
                    <KanBanBoard
                      category_filter={templateId}
                      setEditData={(data) => handleNavigate(null, data)}
                      setActivityState={handleMouseEnterDebounced}
                      fetchKanbanData={fetchKanbanData}
                      iskanaBanDataSuccess={isfetchGetAllTasksSuccess}
                      getkanaBanData={fetchGetAllTasks}
                      iskanaBanDataLoading={isfetchGetAllTasksLoading}
                      iskanaBanDataError={isfetchGetAllTasksError}
                      kanaBanDataError={fetchGetAllTasksError}
                      setSeriesRecurModel={setSeriesRecurModel}
                      setColumnSearchTerms={setColumnSearchTerms}
                      columnSearchTerms={columnSearchTerms}
                    />
                  </>
                }
                handleItemSearch={handleItemSearch}
                otherComponentView={listView === "kanban"}
                hiddenAction={templateId === "projects"}
                leftPanel
                isAdvancedFilterOpen={isAdvancedFilterOpen}
                setIsAdvancedFilterOpen={setIsAdvancedFilterOpen}
                closeAdvancedFilter={closeAdvancedFilter}
                disableSaveFilter={true}
                defaultPinnedColumn={"completionAction"}
                columnVisibility={columnVisibility}
                setColumnVisibility={setColumnVisibility}
                handleReorderFields={(srcInd, targetInd) => handleReorderFields(srcInd + 1, targetInd + 1)}
                columnOrder={columnOrder}
                useGenerateUniqueValues={true}
                generateUniqueValues={generateUniqueValuesForTaskPage}
                buildOptionsFromList={buildOptionsFromList}
                useBuildOptionsFromList={true}
                isViewSwitchable={true}
                compactViewSwitchButton={<CompactViewSwitchButton />}
                subtaskExpanded={subtaskExpanded}
                setSubtaskExpanded={setSubtaskExpanded}
                SubTaskClick={handleNavigate}
                isSubtasKThere
                setTaskIDList={setTaskIDList}
              />
            </div>
          </>
        )}
        {listView === "calendar" && (
          <Fragment>
            {/* {ViewData()} */}
            <RevampedTaskCalendar
              calendarData={memoizeDynamicData ? memoizeDynamicData : []}
              openPopup={openPopup}
              handleEditTask={handleNavigate}
            />
          </Fragment>
        )}

        {openAddProject && (
          <AddViewProjectDrawer
            open={openAddProject}
            setOpen={setOpenAddProject}
            onClose={() => setOpenAddProject(false)}
            customerTaskPodAllCustomer={customerTaskPodAllCustomer}
            setJobFormData={setProjectFormData}
            projectId={editData?.project_id}
            getFieldValue={getFieldValue}
            projectFieldList={projectFieldList}
            fetchPersonInTable={fetchPersonData}
            personTableData={personTableData}
            selectedCustomer={{ id: customerId || projectFormData?.customer_id }}
            refetch={refetchCustomerDataOnly}
            customerTask={customerTask}
          />
        )}

        {isManageFieldOpen && (
          <ManageFieldDrawer
            headerConfig={dynamicHeaders}
            listViewData={
              (columnVisibility && {
                hidden_fields: getHiddenFields(columnVisibility),
                visible_fields: columnOrder,
              }) ??
              {}
            }
            handleFieldVisibility={handleFieldVisibility}
            close={() => setIsManageFieldOpen(false)}
            isOpen={isManageFieldOpen}
            handleReorderFields={handleReorderFields}
            handleSave={handlePostMeta}
          />
        )}
      </div>
      {isPopupOpen && (
        <DynamicAddTaskPodModal
          isOpen={isPopupOpen}
          closePopup={closePopup}
          taskid={editData}
          templateId={templateId}
          completeData={customerMainData}
          customerTask={customerTask}
          customerData={customerData}
          openSubTaskDrawer={openSubTaskDrawer}
          selectedCustomer={{ id: customerId }}
          recurModal={editData?.recurModal}
          activeModal={editData?.activeModal}
          refetchGetAllTasks={handleRefetchGetAllTasks}
          propTemplateId={propTemplateId}
          isMyActivity={!hasMyActivities && null}
          RowData={subTaskData}
          handleSubTaskCardClick={handleSubTaskCardClick}
          handleNavigateParent={handleNavigateParent}
        />
      )}

      {false && // false put for time being rohit sir told to remove this recurrence, check enitre edit or single edit
        editData?.is_recurrence === 1 &&
        !editData?.isDuplicateTask &&
        !editData?.isCopyToTask && (
          <EditOptionsModal
            onClose={closePopup}
            onOpen={editData}
            onSave={handleSaveModal}
            refetch={refetchCustomerData}
            // checkListOpen={isCheckListOpen}
            // setCheckListOpen={setIsCheckListOpen}
          />
        )}

      {deleteData && showConfirmation && (
        <ConfirmationDialog
          open={deleteData && showConfirmation}
          onConfirm={
            deleteData?.is_recurrence === 0 || deleteData?.is_recurrence === null
              ? () => handleDeleteTask("single_task", deleteData)
              : () => handleDeleteTask("this_recurrance_task", deleteData)
          }
          onClose={() => setShowConfirmation(false)}
          title={`Delete this ${showConfirmation} ?`}
          message={
            <>
              This task will be removed permanently and cannot be recovered.
              <br />
            </>
          }
          confirmVariant="delete"
          iconVariant="delete"
          confirmText="Delete"
          cancelText="Cancel"
        />
      )}

      {/* {Boolean(deleteData && deleteData?.is_recurrence) && showConfirmation && (
        <DeleteConfirmModal
          onClose={() => setShowConfirmation(false)}
          onOpen={Boolean(deleteData && deleteData?.is_recurrence) && showConfirmation}
          onSave={(selection) => handleDeleteTask(selection, deleteData)}
          refetch={refetchCustomerData}
          // checkListOpen={isCheckListOpen}
          // setCheckListOpen={setIsCheckListOpen}
        />
      )} */}
    </div>
  );
};

function DebouncedInput({ value: initialValue, onChange, debounce = 200, ...props }) {
  const [value, setValue] = React.useState(initialValue);

  React.useEffect(() => {
    setValue(initialValue); // Sync the input value with the parent prop
  }, [initialValue]);

  React.useEffect(() => {
    const timeout = setTimeout(() => {
      onChange(value); // Call the parent onChange handler after debounce
    }, debounce);

    return () => clearTimeout(timeout);
  }, [value, debounce, onChange]); // Debounce the value change

  return (
    <input
      {...props}
      value={value}
      onChange={(e) => setValue(e.target.value)} // Update internal value on change
      className="text-black text-xs border-none outline-none bg-white p-3"
    />
  );
}

const TaskTable = (props) => {
  const { customerTask } = props;
  const { leadTypePath } = useParams();
  const [searchParams, setSearchParams] = useSearchParams();

  const rightTab = searchParams.get("InTab"); // returns "8"

  const WrappedComponent = useMemo(() => LayoutHOC(AllTasks), [leadTypePath]); // Memoize the wrapped component

  const RefreshedAllTask = useMemo(() => AllTasks, [rightTab]);

  return customerTask ? <RefreshedAllTask key={rightTab} {...props} /> : <WrappedComponent {...props} />;
};

export default TaskTable;
